import { filter } from 'lodash';

export function getSearchTerms(term) {
    return filter(`${term || ''}`.toLowerCase().split(/\s+/), (term) => term && term.length > 0);
}

export function valueContainsTerm(value, term) {
    return value && value.length > 0 && value.toLowerCase().indexOf(term) >= 0;
}



// WEBPACK FOOTER //
// ./src/application/util/search.util.js